import React from 'react';
import InfrastructureHero from '../../components/InfrastructureHero/InfrastructureHero';
import RoadProjects from '../../components/RoadProjects/RoadProjects';
import PublicBuildings from '../../components/PublicBuildings/PublicBuildings';
import UtilitiesDevelopment from '../../components/UtilitiesDevelopment/UtilitiesDevelopment';

const Infrastructure = () => {
  return (
    <div>
      <InfrastructureHero />
      <RoadProjects />
      <PublicBuildings />
      <UtilitiesDevelopment />
    </div>
  );
};

export default Infrastructure;